export default "__VITE_PUBLIC_ASSET__4ec66bc0__"